import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";

function BorderRadius({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"default"} value={"default"}>
          default
        </MenuItem>,
        <MenuItem key={"disabled"} value={"0"}>
          No border radius
        </MenuItem>,
        <MenuItem key={"Circle"} value={"50%"}>
          <div style={{ backgroundColor: "#ccc", borderRadius: "50%", padding: "16px" }}>Circular</div>
        </MenuItem>,
        [4, 8, 12, 16, 20, 24, 28].map((radius) => {
          return (
            <MenuItem key={radius} value={`${radius}px`}>
              <div style={{ backgroundColor: "#ccc", borderRadius: `${radius}px`, padding: "0 4px" }}>{radius}px</div>
            </MenuItem>
          );
        }),
      ]}
      rules={{ required }}
    />
  );
}

export const JSBorderRadiusComponent: JSInputComponent = {
  Component: BorderRadius,
  handlesCssProperties: ["borderRadius"],
};
